import { api } from './api';

export interface Attachment {
  id: string;
  filename: string;
  mime_type: string;
  size_bytes: number;
  created_at: string;
  expires_at: string;
  row_count?: number;
  col_count?: number;
}

export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

export async function uploadAttachment(file: File): Promise<Attachment> {
  if (file.size === 0) {
    throw new Error('file is empty');
  }
  if (file.size > MAX_ATTACHMENT_BYTES) {
    throw new Error(`file exceeds ${MAX_ATTACHMENT_BYTES / 1024 / 1024} MB cap`);
  }
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post<Attachment>('/api/v1/attachments', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    // Uploads of 10 MB may take longer than the default 30s ceiling.
    timeout: 120_000,
  });
  return data;
}

export async function listAttachments(): Promise<Attachment[]> {
  const { data } = await api.get<{ attachments: Attachment[] }>('/api/v1/attachments');
  return data.attachments ?? [];
}

export async function deleteAttachment(id: string): Promise<void> {
  await api.delete(`/api/v1/attachments/${id}`);
}
